exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sole_trader_tooltip{position:relative;left:-10px;float:right;top:-90px}", ""]);

// exports
